export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <g transform="scale(10.666667)">
    <path
      d="M8.00271 18H11.0252V6H8.00271V18ZM14.4103 18H18.0027L13.2704 10.6854L13.2186 12.4888L17.8818 6H14.6521L10.697 11.7135L10.7143 11.9831L14.4103 18Z"
      fill={fill}
    />
  </g>
);
